export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14732.064b1506.jpg";